module.exports = __webpack_public_path__ + "img/bg_taegeuk.b1e8407.png";